<template>
  <div class="loveRecommend clear">
      <StandardCourseCard v-for="(list, index) in data" :key="index" :data="list"></StandardCourseCard>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import {getIndexCourse} from 'api/indexApi'
import StandardCourseCard from '../../../pc/components/standardCourseCard.vue'
export default {
    name: "loveRecommend",
    props: ['ruletype'],
    data() {
        return {
            data: []
        }
    },
    mounted() {
        this.setLoading(true)
        getIndexCourse({
            data: {ruletype: this.ruletype},
            success: data=> {
                this.setLoading(false)
                this.data = data.data.content
            },
            error: data => {
                this.setLoading(false)
                this.$message.error(data.msg)
            }
        })
    },
    methods: {
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        StandardCourseCard
    }
}
</script>

<style lang="scss" type="text/scss">
    .loveRecommend {
        margin: 0 -20px 0 0;
    }
</style>